// src/pages/Dashboard.jsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { Outlet } from "react-router-dom";

export default function Dashboard() {
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const URL= process.env.REACT_APP_SERVER_URL;
  useEffect(() => {
    const fetchDashboardData = async () => {
      //const token = localStorage.getItem("token");

      /*if (!token) {
        navigate("/login");
        return;
      }
        */
        
      try {
        const response = await fetch(`${URL}/api/authOperator/dashboard`, {
          headers: {
            //"Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
           
          },
           credentials:"include"
        });
        

        if (response.ok) {
          const data = await response.json();
          setUserData(data.user);
        } else {
          const err = await response.json();
          setError(err.error || "No autorizado");
        }
      } catch (err) {
        setError("Error al conectar con el servidor");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [navigate]);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-gradient-to-br from-[#102B3F] to-[#2D4A5E]">
        <div className="text-white text-lg font-medium animate-pulse">Cargando panel profesional...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-screen flex items-center justify-center bg-gradient-to-br from-[#102B3F] to-[#2D4A5E]">
        <div className="bg-[#ffdddd] text-red-800 p-6 rounded-xl shadow-lg max-w-md text-center">
          <p className="text-2xl font-bold">Error de acceso</p>
          <p className="mt-2">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-[#0F1F2E] text-white font-sans">
      <Sidebar userData={userData} />
      
      <div className="flex flex-col flex-1 overflow-hidden">
        <Topbar userData={userData} />
        
        <main className="p-8 overflow-y-auto bg-[#1E2B3A] flex-1 rounded-tl-3xl transition-all duration-300 ease-in-out shadow-inner">
          
          {/* Header profesional */}
          {userData && (
            <header className="mb-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
              <div>
                <h1 className="text-3xl font-bold tracking-tight text-white">Bienvenido, {userData.name}</h1>
                <p className="text-sm text-gray-300 mt-1">Administra tus servicios turísticos de manera eficiente.</p>
              </div>
              <div className="mt-4 sm:mt-0">
                <button
                  onClick={() => navigate("/profile")}
                  className="bg-[#2D4A5E] text-white px-4 py-2 rounded-xl hover:bg-[#3c627c] transition duration-200 shadow-md"
                >
                  Ver perfil
                </button>
              </div>
            </header>
          )}

          {/* Contenido dinámico del dashboard */}
          <section className="bg-[#26394D] p-6 rounded-2xl shadow-xl min-h-[300px] transition-all">
            <Outlet />
          </section>
        </main>
      </div>
    </div>
  );
}
